import Page from "components/page/Page";
import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router";
import WebsiteBuilderTemplate from "./WebsiteBuilderTemplate";
import "./websiteBuilderTemplates.scss";
import { useWebsite } from "../shared/hooks/useWebsite";
import { WebsiteBuilderLoadingContent } from "./components/loadingContent/WebsiteBuilderLoadingContent";
import { GetWebsiteBuilderTemplates } from "api/rpc/2024-04/facilityAdmin/websiteBuilder/websiteBuilder";
import { StatusCode } from "api/protocols";
import { useAppDispatch } from "hooks/redux";
import { showError } from "redux/actions/ui";
import { IWebsiteBuilderTemplate } from "redux/reducers/models/websiteBuilder";
import axios, { CancelToken } from "axios";
import { useWebsiteBuilderLoadingState } from "../shared/hooks/useWebsiteBuilderLoadingState";
import { useTranslation } from "react-i18next";

export default function WebsiteBuilderTemplates() {
  const { t } = useTranslation();
  
  const dispatch = useAppDispatch();

  const history = useHistory();

  const {
    websiteLoadingStatus,
  } = useWebsite({ websiteMustExist: false });

  const {
    state: templates,
    stateExists: templatesExist,
    stateLoadingStatus: templatesLoadingStatus,
    loadInProgress: templatesLoadInProgress,
    loadFailed: templatesLoadFailed,
    loadSucceeded: templatesLoadSucceeded,
  } = useWebsiteBuilderLoadingState<IWebsiteBuilderTemplate[]>({
    state: null,
    stateExists: false,
    stateLoadingStatus: "loading",
  });

  const loadTemplates = useCallback(async (token: CancelToken) => {
    templatesLoadInProgress();

    const res = await GetWebsiteBuilderTemplates(false, token);

    if (res.status !== StatusCode.OK) {
      if (!token.reason) {
        templatesLoadFailed();
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error loading templates")));
      }

      return;
    }

    templatesLoadSucceeded(res.data, res.data?.length > 0);
  }, []);

  useEffect(() => {
    const source = axios.CancelToken.source();

    void loadTemplates(source.token);

    return () => source.cancel();
  }, [loadTemplates]);

  function renderTemplates() {
    if (websiteLoadingStatus === "succeeded" && templatesLoadingStatus === "succeeded" && templatesExist) {
      return (
        <div className="website-builder-templates">
          {templates.map(template => {
            return (
              <WebsiteBuilderTemplate
                key={template.id}
                template={template}
                onClick={() => history.push(`/admin/website-builder/templates/${template.id}`)}
              />
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <Page
      narrow
      title={t("Choose a website template")}
      subtitle={t("Select a template to begin building your site")}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Go back"),
          url: "/admin/website-builder",
        },
      ]}
    >
      <WebsiteBuilderLoadingContent loading={websiteLoadingStatus === "standby" || websiteLoadingStatus === "loading" || templatesLoadingStatus === "loading"}>
        {renderTemplates()}
      </WebsiteBuilderLoadingContent>
    </Page>
  );
}
